module.exports = __webpack_public_path__ + "img/filter-icon.17f40b28.svg";